import Head from "next/head"
import React from "react"
import { getProviders } from "next-auth/client"

const defaultSteps = [
  { id: "Step 1", name: "Account Creation", href: "?step=1", status: "current" },
  { id: "Step 2", name: "Plan Selection", href: "?step=2", status: "upcoming" },
]

export default function Signup() {
  // export default function Signup({ providers }) {
  // const { query } = useRouter()
  // const [steps, setSteps] = useState(defaultSteps)

  // useEffect(() => {
  //   if (!query.step || query.step === "1") {
  //     setSteps([
  //       { id: "Step 1", name: "Account Creation", href: "?step=1", status: "current" },
  //       { id: "Step 2", name: "Plan Selection", href: "?step=2", status: "upcoming" },
  //     ])
  //   } else if (query.step === "2") {
  //     setSteps([
  //       { id: "Step 1", name: "Account Creation", href: "?step=1", status: "complete" },
  //       { id: "Step 2", name: "Plan Selection", href: "?step=2", status: "current" },
  //     ])
  //   }
  // }, [query.step])

  return (
    <div className="flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <Head>
        <title>Sign up | Skillfyre</title>
      </Head>
      <div>
        <h1 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Build a life you love
        </h1>
        <p className="mt-2 text-center text-sm text-gray-600">
          Request an invite to the Alpha experience
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-lg flex items-center justify-center">
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLScRrMnrwv2h3aPrfYRZeTdG05TqfHt_xywpxZMpdsQdnWwV-Q/viewform?usp=sf_link"
          className="btn">
          Get an Invite
        </a>
        {/* <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10"> */}
        {/* <Steps steps={steps as Step[]} currStep={Number(query.step) - 1 || 0} />
          {!query.step || query.step === "1" ? (
            <AccountCreation providers={providers} />
          ) : query.step === "2" ? (
            <PlanSelection />
          ) : null} */}
        {/* </div> */}
      </div>
    </div>
  )
}

// export async function getServerSideProps(context) {
//   const providers = await getProviders()
//   return {
//     props: { providers },
//   }
// }
